import { render, staticRenderFns } from "./AlphaNotice.vue?vue&type=template&id=9fcb0db4&scoped=true&"
import script from "./AlphaNotice.vue?vue&type=script&lang=js&"
export * from "./AlphaNotice.vue?vue&type=script&lang=js&"
import style0 from "./AlphaNotice.vue?vue&type=style&index=0&id=9fcb0db4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcb0db4",
  null
  
)

export default component.exports